import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private _isLoading = new BehaviorSubject<boolean>(false);
  private _loadingCounter = 0;
  public readonly isLoading$: Observable<boolean> = this._isLoading.asObservable();

  /**
   * Shows the loader
   * @param forceShow Optionally force the loader to show regardless of counter
   */
  showLoader(forceShow: boolean = false): void {
    if (forceShow) {
      this._isLoading.next(true);
      return;
    }

    this._loadingCounter++;
    if (this._loadingCounter > 0) {
      this._isLoading.next(true);
    }
  }

  /**
   * Hides the loader
   * @param forceHide Optionally force the loader to hide regardless of counter
   */
  removeLoader(forceHide: boolean = false): void {
    if (forceHide) {
      this._loadingCounter = 0;
      this._isLoading.next(false);
      return;
    }

    this._loadingCounter = Math.max(0, this._loadingCounter - 1);
    if (this._loadingCounter === 0) {
      this._isLoading.next(false);
    }
  }

  /**
   * Gets the current loading state
   */
  get isLoading(): boolean {
    return this._isLoading.value;
  }
}
